import { Component, Input } from '@angular/core';
import { FirstHydroInstructionDto } from 'src/app/core/Dtos/fhc-hydro/instructions-dto';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { FhcHydroService } from 'src/app/core/services/fhc-hydro.service';
import { UserService } from 'src/app/core/user.service';

@Component({
  selector: 'app-fhc-viewer',
  templateUrl: './fhc-viewer.component.html',
  styleUrl: './fhc-viewer.component.scss',
  standalone: false
})
export class FhcViewerComponent {
  @Input() public set InstructionId(instructionId: string | number) {
    if (instructionId !== 0)
      this.GetInstruction(instructionId);
    this._instructionId = instructionId;
  };
  public Instruction: FirstHydroInstructionDto = new FirstHydroInstructionDto();

  private _instructionId: string | number = '';

  constructor(
    private _fhcHydroService: FhcHydroService,
    private _alertService: AlertsService,
    public DateFormatHelper: DateFormatHelperService,
    public UserService: UserService,) {
  }



  GetInstruction(instructionId: string | number) {
    this._fhcHydroService.GetInstructionById(instructionId).subscribe(
      resp => {
        this.Instruction = resp;
      }
    )
  }
  ChangeStatus(status: string) {
    this._fhcHydroService.ChangeStatus(this._instructionId, status).subscribe(
      resp => {
        this.GetInstruction(this._instructionId);
      }
    )
  }

  Formatext(text: string): string {
    debugger;
    if (!text) {
        return '';
    }
    return text
        .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;') // Replace \t with tabs
        .replace(/\n/g, '<br/>'); // Replace \n with <br/>
  }
}
